import { useMemo, useRef, useState, useEffect } from "react";
import COMUNI from "../lib/comuni";
import { Input } from "./ui/input";

const PROVINCE = [...new Set(COMUNI.map((c) => c.provincia))].filter(Boolean).sort();

// Campo predittivo sui comuni italiani: mode "nome" (comune), "cap" o "prov" (sigla provincia).
// onPick(comune) riceve { nome, provincia, cap } per compilare i campi collegati.
export default function ComuneField({ mode = "nome", value, onChange, onPick, testId, className = "", placeholder }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  const items = useMemo(() => {
    const q = (value || "").trim().toLowerCase();
    if (mode === "prov") return q ? PROVINCE.filter((p) => p.toLowerCase().startsWith(q)).slice(0, 12).map((p) => ({ key: p, label: p, prov: p })) : [];
    if (q.length < 2) return [];
    const pool = mode === "cap" ? COMUNI.filter((c) => (c.cap || "").startsWith(q)) : COMUNI.filter((c) => c.nome.toLowerCase().startsWith(q));
    const more = mode === "nome" && pool.length < 12 ? COMUNI.filter((c) => !c.nome.toLowerCase().startsWith(q) && c.nome.toLowerCase().includes(q)) : [];
    return [...pool, ...more].slice(0, 12).map((c) => ({ key: `${c.nome}-${c.provincia}`, label: `${c.nome} (${c.provincia})${c.cap ? ` \u00b7 ${c.cap}` : ""}`, c }));
  }, [value, mode]);
  const pick = (it) => {
    setOpen(false);
    if (mode === "prov") { onChange(it.prov); return; }
    onChange(mode === "cap" ? it.c.cap : it.c.nome);
    onPick && onPick(it.c);
  };
  return (
    <div ref={ref} className="relative">
      <Input value={value || ""} placeholder={placeholder} autoComplete="off" data-testid={testId}
        onChange={(e) => { onChange(mode === "prov" ? e.target.value.toUpperCase().slice(0, 2) : e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)} className={className} />
      {open && items.length > 0 && (
        <div className="absolute z-50 mt-1 w-full max-h-56 overflow-y-auto rounded-md border border-slate-700 bg-[#121824] shadow-xl" data-testid={`${testId}-list`}>
          {items.map((it, i) => (
            <button type="button" key={it.key} onMouseDown={(e) => { e.preventDefault(); pick(it); }} data-testid={`${testId}-opt-${i}`}
              className="block w-full text-left px-3 py-1.5 text-sm text-slate-100 hover:bg-slate-800">{it.label}</button>
          ))}
        </div>
      )}
    </div>
  );
}
